module.exports = __webpack_public_path__ + "static/media/defaultAvatar20.3ca1e3f0.svg";